export const KarmaPoolStripePaymentManager = (local, setLocal, getURLBasePath) => {

    function createPaymentIntent(paymentCallback) {
        fetch(getURLBasePath() + 'paymentIntent', {
            method: 'POST',
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify({ paymentMethodType: "card", currency: "gbp", currencyAmount: 200 })
        })
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                paymentCallback(data)
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    function cancelSubscription(cancelCallback) {
        fetch(getURLBasePath() + 'cancelSubscription', {
            method: 'POST',
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            }),
            // empty body
            body: JSON.stringify({})
        })
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                cancelCallback(data)
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    function getPaymentLink(amount, paymentCallback) {
        fetch(getURLBasePath() + 'subscriptionPaymentLink?amount=' + amount, {
            method: 'GET',
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            })
        })
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                paymentCallback(data)
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    return {
        createPaymentIntent, getPaymentLink, cancelSubscription
    };
}